import { render, staticRenderFns } from "./CircularBackground.vue?vue&type=template&id=4a4b0b61&scoped=true"
import script from "./CircularBackground.vue?vue&type=script&lang=js"
export * from "./CircularBackground.vue?vue&type=script&lang=js"
import style0 from "./CircularBackground.vue?vue&type=style&index=0&id=4a4b0b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b0b61",
  null
  
)

export default component.exports